// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:12
import { GeoFenceRequestArgs_abstract } from './../abstract/SagaBase/GeoFenceRequestArgs_abstract';
export class GeoFenceRequestArgs extends GeoFenceRequestArgs_abstract {}
